export default "__VITE_ASSET__3b514cca__"